export const legendOptions = [
  { label: 'Bronpotentieel', value: 'potential' },
  { label: 'Temperatuurdaling', value: 'temperature' },
  { label: 'Totale Warmte geleverd', value: 'heat-delivered' },
];

export const defaultLegendMode = legendOptions[0].value;
